import SC from "./style";
import { Typography } from "@InnoUI";

const Logo = ({ path, height, width, alt, ...props }) => {
  return (
    <Typography {...SC.Container} {...props}>
      <img src={path} alt={alt} {...SC.img} height={height} />
    </Typography>
  );
};

export default Logo;
